import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeMapsComponent } from '../maps/safe-maps.component';
import {
  CalendarIcon,
  ClockIcon,
  LucideAngularModule,
  PhoneIcon,
  MapPinIcon,
  CircleIcon,
} from 'lucide-angular';
import { RouterModule } from '@angular/router';
import { CountryStorageService } from '../../../core/services/country.storage.service';
import { Country } from '../../../core/interfaces/doctor.interface';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-card-pharmacy',
  standalone: true,
  imports: [CommonModule, SafeMapsComponent, LucideAngularModule, RouterModule],
  templateUrl: './card-pharmacy.component.html',
  styleUrls: ['./card-pharmacy.component.scss'],
})
export class CardPharmacyComponent implements OnInit {
  @Input() pharmacy: any;

  selectedCountry: Country | null = null;
  PrefixUrlCountryCode: string = '';

  readonly PhoneIcon = PhoneIcon;
  readonly ClockIcon = ClockIcon;
  readonly CalendarIcon = CalendarIcon;
  readonly MapPinIcon = MapPinIcon;
  readonly CircleIcon = CircleIcon;

  constructor(
    private countryStorage: CountryStorageService,
    private themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    this.countryStorage.country$.subscribe((country) => {
      this.selectedCountry = country;
      this.PrefixUrlCountryCode = `/${this.selectedCountry?.code?.toLowerCase()}`;
    });
  }

  roundDistance(distance: number): string {
    if (distance < 999) {
      return `${Math.round(distance / 50) * 50} m`;
    } else {
      return `${Math.round(distance / 100) / 10} km`;
    }
  }

  // Nom du produit selon le thème (FA'JMA ou Passeport Médical)
  getProductName(): string {
    return this.themeService.getProductName();
  }
}
